import React from 'react';
import TimeSlot from 'src/components/ServiceRequestForm/TimeSlot/TimeSlot';
import { PreferredServiceDay } from 'src/components/ServiceRequestForm/TimeSlot/timeSlotHelpers';
import { IAvailableServiceTimeDay } from 'src/services/api/UserManagement/apiContracts';
import Button from 'src/components/Button';
import ServiceRequestTimeslotPicker from 'src/pages/ServiceRequest/components/ServiceRequestTimeslotPicker/ServiceRequestTimeslotPicker';
import './manual-scheduling-panel.scss';

interface ManualSchedulingPanelProps {
  preferredServiceTimes: PreferredServiceDay[];
  slotSelected: boolean;
  availableServiceTimes: IAvailableServiceTimeDay[];
  scheduledAt: any | null;
  onTimeSlotSelection: (selection: string) => Promise<void>;
  onScheduledAtChange: (scheduledAt: any) => void;
  onScheduleClick: () => void;
}

const ManualSchedulingPanel = ({
  preferredServiceTimes,
  slotSelected,
  availableServiceTimes,
  scheduledAt,
  onTimeSlotSelection,
  onScheduledAtChange,
  onScheduleClick,
}: ManualSchedulingPanelProps) => {
  return (
    <div className="manual-scheduling-panel">
      <div className="manual-scheduling-slots">
        <TimeSlot
          from="srscheduling"
          fromScheduling={preferredServiceTimes}
          onSelectionChange={(selection: string) =>
            void onTimeSlotSelection(selection)
          }
        />
        <div className="manual-scheduling-picker">
          {slotSelected && (
            <ServiceRequestTimeslotPicker
              availableServiceTimes={availableServiceTimes}
              setFormData={(formData: any) =>
                onScheduledAtChange(formData?.scheduledAt)
              }
            />
          )}
        </div>
      </div>
      <div className="manual-scheduling-action">
        <Button
          label="Schedule"
          color="teal"
          size="small"
          disabled={!scheduledAt}
          onClick={() => onScheduleClick()}
        />
      </div>
    </div>
  );
};

export default ManualSchedulingPanel;